export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Warm%20minimalist%20fashion%20discovery%20scene%20with%20neatly%20displayed%20sneakers%2C%20hoodies%20and%20accessories%20on%20light%20oak%20shelving%2C%20soft%20natural%20daylight%20streaming%20through%20large%20window%20creating%20gentle%20shadows%2C%20cream%20and%20warm%20beige%20color%20palette%2C%20organic%20textures%20with%20linen%20and%20wood%2C%20curated%20lifestyle%20boutique%20aesthetic%2C%20editorial%20catalog%20photography%2C%20airy%20and%20spacious%20composition%20with%20depth&width=1600&height=900&seq=hero-bg-v2&orientation=landscape')`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>

      <div className="relative z-10 w-full max-w-screen-xl mx-auto px-4 md:px-6 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          <div className="flex-1 text-center lg:text-left w-full">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 backdrop-blur-sm border border-primary-400/30 mb-6">
              <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
              <span className="text-xs font-medium text-primary-200">Updated Daily</span>
            </div>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-6">
              The Ultimate{' '}
              <span className="text-primary-300 italic">Sugargoo Spreadsheet</span>
              {' '}Resource
            </h1>

            <p className="text-base md:text-lg text-background-200/90 max-w-xl mx-auto lg:mx-0 mb-8 leading-relaxed">
              Discover thousands of organized product finds, shopping guides, shipping information, coupons, reviews and expert tips — all in one beautifully curated destination.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-base font-semibold hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap shadow-lg shadow-primary-500/25"
              >
                Sugargoo Spreadsheet
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 text-base font-medium hover:bg-background-50/25 transition-all cursor-pointer whitespace-nowrap"
              >
                Buy It Now
              </a>
            </div>

            <div className="flex flex-wrap items-center gap-5 justify-center lg:justify-start mt-8">
              <div className="flex items-center gap-1.5">
                <i className="ri-checkbox-circle-fill text-accent-400 text-sm"></i>
                <span className="text-xs text-background-200/80">Beginner Friendly</span>
              </div>
              <div className="flex items-center gap-1.5">
                <i className="ri-checkbox-circle-fill text-accent-400 text-sm"></i>
                <span className="text-xs text-background-200/80">Curated Products</span>
              </div>
              <div className="flex items-center gap-1.5">
                <i className="ri-checkbox-circle-fill text-accent-400 text-sm"></i>
                <span className="text-xs text-background-200/80">Free Resource</span>
              </div>
              <div className="flex items-center gap-1.5">
                <i className="ri-checkbox-circle-fill text-accent-400 text-sm"></i>
                <span className="text-xs text-background-200/80">Weekly Updates</span>
              </div>
            </div>
          </div>

          <div className="flex-1 hidden lg:flex justify-center">
            <div className="relative w-full max-w-md">
              <div className="bg-background-50/10 backdrop-blur-md border border-background-50/15 rounded-2xl p-6">
                <div className="grid grid-cols-3 gap-3">
                  {[1, 2, 3, 4, 5, 6].map((i) => (
                    <div
                      key={i}
                      className="aspect-square rounded-xl bg-background-50/15 backdrop-blur-sm flex items-center justify-center"
                    >
                      <i className={`text-2xl text-background-50/50 ${i % 2 === 0 ? 'ri-footprint-line' : 'ri-shirt-line'}`}></i>
                    </div>
                  ))}
                </div>
                <div className="mt-4 h-2 rounded-full bg-background-50/10 overflow-hidden">
                  <div className="h-full w-2/3 rounded-full bg-primary-400/60"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}